import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export const usageTracker = createTracker({
  events
});